<div class="center_scrollable_wrapper">
  <ng-content></ng-content>
</div>
